import { formatDistanceToNow } from "date-fns"

/** Under a minute reads as "Just now" so a dot that just dropped is not "less than a minute ago". */
export function formatLastSeen(lastSeenAt: number | undefined): string {
	if (!lastSeenAt) return "Never signed in"
	const elapsed = Date.now() - lastSeenAt
	if (elapsed < 60_000) return "Just now"
	return `${formatDistanceToNow(new Date(lastSeenAt))} ago`
}

/** The whole presence line, so no caller has to prefix "Last seen" itself. */
export function formatPresenceLabel(
	isOnline: boolean,
	lastSeenAt: number | undefined,
): string {
	if (isOnline) return "Online now"
	if (!lastSeenAt) return "Never signed in"
	return `Last seen ${formatLastSeen(lastSeenAt).toLowerCase()}`
}
